import type { Contract } from "@utah-vr/shared";

export async function fetchContracts(): Promise<{ contracts: Contract[] }> {
	const res = await fetch("/api/contracts/active");
	if (!res.ok) throw new Error(`contracts fetch failed: ${res.status}`);
	return res.json();
}

export async function acceptContract(id: string): Promise<Contract> {
	const res = await fetch(`/api/contracts/${encodeURIComponent(id)}/accept`, { method: "POST" });
	if (!res.ok) throw new Error(`accept failed: ${res.status}`);
	return res.json();
}
